// extracted by mini-css-extract-plugin
export default {"emptySpaceBelow":"QuestionDetail_emptySpaceBelow__LzAks"};